import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * WCST — FTUE demo skeleton.
 *
 * 3 essais pedagogiques :
 *   E1 : regle couleur, feedback explicite.
 *   E2 : regle forme, feedback explicite.
 *   E3 : mecanique rule shift expliquee.
 */
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
const DEMO_STEPS = [
    { idx: 1, titleKey: 'wcst.demo.step1_title', hintKey: 'wcst.demo.step1_hint' },
    { idx: 2, titleKey: 'wcst.demo.step2_title', hintKey: 'wcst.demo.step2_hint' },
    { idx: 3, titleKey: 'wcst.demo.step3_title', hintKey: 'wcst.demo.step3_hint' },
];
export function Demo({ onComplete, onSkip }) {
    const { t } = useTranslation(['games', 'common']);
    const [stepIdx, setStepIdx] = useState(0);
    const step = DEMO_STEPS[stepIdx];
    const isLast = stepIdx === DEMO_STEPS.length - 1;
    const handleNext = () => {
        if (isLast)
            onComplete();
        else
            setStepIdx((i) => i + 1);
    };
    return (_jsxs("div", { className: "flex flex-1 flex-col items-center gap-s4 py-s4 text-center", children: [_jsx("p", { className: "font-mono text-[9.5px] uppercase tracking-[0.30em] text-cyan-text-faint", children: t('wcst.demo.eyebrow') }), _jsx("h2", { className: "font-display text-[22px] italic leading-7 text-cyan-text", children: t(step.titleKey) }), _jsx("p", { className: "max-w-[320px] text-[13.5px] text-cyan-text-secondary", children: t(step.hintKey) }), _jsx("div", { className: "flex h-[200px] w-full items-center justify-center border border-cyan-border-faint bg-cyan-surface", children: _jsx("span", { className: "text-cyan-text-secondary text-[13px]", children: t('wcst.demo.placeholder') }) }), _jsxs("div", { className: "flex flex-col items-stretch gap-s3 self-stretch", children: [_jsx("button", { type: "button", onClick: handleNext, className: "inline-flex h-12 w-full items-center justify-center bg-cyan-core font-display text-[14px] font-medium tracking-[-0.01em] text-cyan-surface transition active:scale-[0.985] hover:bg-cyan-network", children: isLast ? t('common:actions.start_session') : t('common:actions.next_trial') }), _jsx("button", { type: "button", onClick: onSkip, className: "text-[12px] text-cyan-text-secondary underline-offset-4 hover:underline", children: t('common:actions.skip_demo') })] })] }));
}
//# sourceMappingURL=demo.js.map